var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import ReactTooltip from 'react-tooltip';
var cls = classNames('with-tooltip');
export var WithTooltipDefaultProps = {};
// -------- Styles -------->
var TooltipBodyStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: left;\n    font-size: ", ";\n  "], ["\n    text-align: left;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(11))
});
var TooltipStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-transform: none;\n    max-width: 200px;\n    line-height: 1.3em;\n    font-weight: 400;\n    font-size: ", ";\n  "], ["\n    text-transform: none;\n    max-width: 200px;\n    line-height: 1.3em;\n    font-weight: 400;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(11))
});
var TooltipTargetStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'WithTooltip',
  Tooltip: styled(ReactTooltip)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles),
  TooltipTarget: styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TooltipTargetStyles),
  TooltipBody: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TooltipBodyStyles)
};
export var WithTooltip = function (props) {
  var componentProps = useComponentProps(My.NAME, WithTooltipDefaultProps, props);
  var children = componentProps.children,
    id = componentProps.id,
    content = componentProps.content,
    className = componentProps.className;
  if (!id) {
    console.warn('Tooltip requires an id to be set');
  }
  var hasTooltip = !!content && !!id;
  React.useEffect(function () {
    if (hasTooltip) {
      ReactTooltip.rebuild();
    }
  }, []);
  return React.createElement(React.Fragment, null, hasTooltip && React.createElement(My.Tooltip, {
    className: className,
    id: "tooltip-".concat(id),
    effect: "solid",
    place: "top",
    type: "light",
    delayHide: 300,
    delayShow: 100,
    offset: {
      top: 0,
      left: 0
    },
    textColor: "#FFFFFFFF",
    backgroundColor: "#333333",
    clickable: true,
    wrapper: "span"
  }, React.createElement(My.TooltipBody, {
    id: "tooltip-".concat(id)
  }, content)), hasTooltip ? React.createElement(My.TooltipTarget, {
    "data-for": "tooltip-".concat(id),
    "data-tip": ""
  }, children) : children);
};
WithTooltip.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;